export const getObservationData = (observations) => {
  var FieldVisit = 0;
  var ClientReport = 0;
  var StaffReport = 0;
  var EmailDocumentation = 0;
  var PictureDocumentation = 0;

  observations.forEach((obs) => {
    if (obs.hasOwnProperty("Type")) {
      if (obs["Type"] === "Field Visit") {
        FieldVisit += 1;
      } else if (obs["Type"] === "Client Report") {
        ClientReport += 1;
      } else if (obs["Type"] === "Staff Report") {
        StaffReport += 1;
      } else if (obs["Type"] === "Email Documentation") {
        EmailDocumentation += 1;
      } else if (obs["Type"] === "Picture Documentation") {
        PictureDocumentation += 1;
      }
    }
  });

  return [
    {
      order: 1,
      name: `Field Visit (${FieldVisit})`,
      value: FieldVisit,
      color: "#349fda",
    },
    {
      order: 2,
      name: `Client Report (${ClientReport})`,
      value: ClientReport,
      color: "#fdd835",
    },
    {
      order: 3,
      name: `Staff Report (${StaffReport})`,
      value: StaffReport,
      color: "#ff9800",
    },
    {
      order: 4,
      name: `Email Documentation (${EmailDocumentation})`,
      value: EmailDocumentation,
      color: "#50C878",
    },
    {
      order: 5,
      name: `Picture Documentation (${PictureDocumentation})`,
      value: PictureDocumentation,
      color: "#7e57c2",
    },
  ];
};
